'use client';

/* 国家数据初始化（客户端组件） */
import { useStores } from '@/models';
import { useEffect } from 'react';

import { setI18nLang } from '@/i18n/settings';
import { setDefaultLocalAddress } from '@/utils/addressRequestUtils';
import { getAddressCookie } from '@/utils/addressUtils';
import cookieUtils from '@/intl-jdi-common-ssr/utils/cookieUtils';
import {
  ADDRESS_CATEGORY_VALUES,
  ADDRESS_EVENT_NAMES,
  addressBusinessLogger,
} from '@/utils/logger/instance/addressBusinessLogger';

import { Address, Country, Currency, Language } from '@/apis/address/address.interface';

interface CountryData {
  currentCountryData: Country | null;
  currentCountryCode: string;
  countryList: Country[];
  supportLanguageList: Language[];
  supportCurrencyList: Currency[];
  currentLanguageCode: string;
  currentLanguageData: Language;
  currentCurrencyCode: string;
  currentCurrencyData: Currency;
  hasPermission: boolean;
  updateAddressCacheTag: string;
  apiResponse: any;
}

const ClientCountryDataInitializer = ({
  serverCountryData,
}: {
  serverCountryData: CountryData;
}) => {
  const {
    currentCountryData,
    currentCountryCode,
    countryList,
    supportLanguageList,
    supportCurrencyList,
    currentLanguageCode,
    currentLanguageData,
    currentCurrencyCode,
    currentCurrencyData,
    hasPermission,
    updateAddressCacheTag,
  } = serverCountryData;
  const { countryStore } = useStores();

  useEffect(() => {
    const initData = async () => {
      // 地址
      await setDefaultLocalAddress({
        currentCountry: currentCountryData,
        currentCountryCode,
        updateAddressCacheTag,
      });

      const currentAddress = getAddressCookie() as Address;

      // 语言
      if (currentLanguageCode) {
        setI18nLang(currentLanguageCode);
      }
      // 货币
      if (currentCurrencyCode) {
        cookieUtils.setCookie('_currency', currentCurrencyCode, 90);
      }

      countryStore.initCountryData({
        ...serverCountryData,
        currentAddress,
      });

      console.info('[SSR] initCountryData:', serverCountryData);

      // 国家初始化异常上报
      const isDataComplete =
        currentCountryData &&
        currentCountryCode &&
        countryList?.length > 0 &&
        supportLanguageList?.length > 0 &&
        currentLanguageCode &&
        currentLanguageData &&
        supportCurrencyList?.length > 0 &&
        currentCurrencyCode &&
        currentCurrencyData;

      if (!isDataComplete) {
        addressBusinessLogger({
          eventName: ADDRESS_EVENT_NAMES.COUNTRY_DATA_INIT_ERROR,
          category: {
            module: ADDRESS_CATEGORY_VALUES.MODULE.LAYOUT,
            action: ADDRESS_CATEGORY_VALUES.ACTION.REQUEST,
            result: ADDRESS_CATEGORY_VALUES.RESULT.ERROR,
          },
          message: {
            serverCountryData: JSON.stringify(serverCountryData),
          },
        });
      }
    };

    initData();
  }, [
    currentCountryData,
    currentCountryCode,
    currentLanguageCode,
    currentCurrencyCode,
    hasPermission,
  ]);

  return null;
};

export default ClientCountryDataInitializer;
